export const LOCAL_STORAGE_KEYS = {
  REFRESH_TOKEN: 'refresh_token',
  THEME_PREFERENCE: 'theme_preference',
} as const;

export const SESSION_STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  GOOGLE_CREDENTIAL: 'google_credential',
} as const;
